import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Img = styled.img`
  margin: 0;
  width: 100%;

  ${breakpoint("tablet")`
    cursor: pointer;
  `}
`

export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0%;
  overflow: hidden;
  z-index: 1;
`

export const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`
